<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh"
        :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <presidi-prestazioni-list-component ref="PresidiPrestazioniListComponent"
                @afterLoadData="onAfterLoadData"></presidi-prestazioni-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PresidiPrestazioniListComponent from "../components/PresidiPrestazioniListComponent.vue";
export default {
    components: { SaPageLayout, PresidiPrestazioniListComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "/ricettaprestazionipresidio",
            linkedit: "/presidiprestazioni",
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.PresidiPrestazioniListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
